var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { jsx as _jsx } from "react/jsx-runtime";
import OptionWithCheckbox from '../OptionWithCheckbox';
export var SelectAllOption = function (props) {
    var _a;
    var _b = props.selectProps, options = _b.options, value = _b.value, onChange = _b.onChange, selectAllLabel = _b.selectAllLabel;
    if (!props.isMulti || (!Array.isArray(value) && value !== null))
        return null;
    var flatOptions = (_a = options) === null || _a === void 0 ? void 0 : _a.reduce(function (acc, next) {
        if (next.options)
            return __spreadArray(__spreadArray([], acc), next.options);
        return __spreadArray(__spreadArray([], acc), [next]);
    }, []);
    var flatOptionsWithoutDuplicates = flatOptions.reduce(function (acc, next) {
        var exists = acc.find(function (el) { return el.value === next.value; });
        if (!exists)
            acc.push(next);
        return acc;
    }, []);
    var SELECT_OPTION_META_DATA = {
        action: 'select-option',
        name: 'all-option',
    };
    var handleChange = function (value) {
        if (value)
            onChange(flatOptionsWithoutDuplicates, SELECT_OPTION_META_DATA);
        else
            onChange([], SELECT_OPTION_META_DATA);
    };
    var getSelectAllLabel = function () {
        if (selectAllLabel) {
            return selectAllLabel;
        }
        return 'Select All';
    };
    var isSelected = flatOptionsWithoutDuplicates.length === (value === null || value === void 0 ? void 0 : value.length);
    return props.isMulti ? (_jsx(OptionWithCheckbox, __assign({ isSelected: isSelected, onClick: handleChange, indeterminate: !!(value === null || value === void 0 ? void 0 : value.length) && !isSelected }, props, { children: getSelectAllLabel() }), void 0)) : null;
};
